import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, LeafIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-32">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-33">
        <div className="absolute top-[-10%] left-[-5%] w-64 h-64 rounded-full bg-sage blur-3xl" data-id="element-34" />
        <div className="absolute top-[20%] right-[-10%] w-80 h-80 rounded-full bg-terracotta blur-3xl opacity-20" data-id="element-35" />
      </div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-lightSage text-sage font-medium mb-8" data-id="element-37">
          <SparklesIcon className="w-4 h-4" data-id="element-38" />
          <span className="text-sm tracking-wide uppercase" data-id="element-39">
            El método práctico y real
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight" data-id="element-40">
          PLAN PANCITA DESINFLAMADA
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-2xl md:text-3xl font-serif text-terracotta mb-8 italic" data-id="element-41">
          Recuperá tu ligereza en 7 días
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-lg md:text-xl text-brown/80 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-42">
          El método práctico para desinflamar tu abdomen usando lo que ya tenés
          en el súper de la vuelta, sin dietas imposibles ni productos caros.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="bg-white/60 backdrop-blur-sm p-6 md:p-8 rounded-3xl shadow-sm border border-sage/20 max-w-3xl mx-auto mb-12 text-left relative" data-id="element-43">
          <LeafIcon className="absolute -top-4 -left-4 w-8 h-8 text-sage opacity-50 rotate-[-15deg]" data-id="element-44" />
          <p className="text-brown/90 text-lg leading-relaxed" data-id="element-45">
            ¿Te pasa que te levantás con la panza chata y para las 4 de la tarde
            sentís que el jean te corta la respiración? No es grasa, es
            inflamación. Y no, no se soluciona tomando jugos verdes amargos ni
            gastando una fortuna en dietéticas.
          </p>
          <p className="text-brown/90 text-lg leading-relaxed mt-4" data-id="element-46">
            Vivís con el abdomen hinchado porque tu sistema digestivo está
            pidiendo una tregua del estrés, los ultraprocesados "disfrazados de
            saludables" y el ritmo acelerado de todos los días. Es hora de darle
            un reseteo real.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} data-id="element-47">
          <a href="#oferta" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-sage rounded-full shadow-lg hover:bg-sage/90 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative overflow-hidden group" data-id="element-48">
            <span className="relative z-10" data-id="element-49">¡QUIERO MI PLAN AHORA!</span>
            <div className="absolute inset-0 h-full w-full bg-white/20 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500 ease-out" data-id="element-50" />
          </a>
        </motion.div>
      </div>
    </section>;
}